<template>
  <!-- TODO check src/components/my/order/Delivering.vue:1 -->
  <!-- TODO check src/components/my/order/DeliveringItem.vue:1 -->
  <!-- TODO check src/components/my/order/MoveDeliveryTracking.vue:1 -->
  <InProgressOrders
    :inProgressOrders="inProgressOrders"
    :onOrderDetail="redirectOrderDetail"
    :onDeliveryTracking="redirectDeliveryTracking"
    :chatbotStatus="chatbotStatus"
    :onChatbot="onChatbot"
  />
</template>

<script>
import InProgressOrders from '../../layouts/organisms/InProgressOrders/index'
import { Location, MoveType } from '@/plugins/AppManager'
import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'InProgressOrdersContainer',
  components: { InProgressOrders },
  computed: {
    inProgressOrders() {
      return this.$store.getters['myOrderHistoryV2/inProgressOrders']
    },
    chatbotStatus() {
      return this.$store.getters['myOrderHistoryV2/chatbotStatus']
    }
  },
  methods: {
    redirectOrderDetail(orderId) {
      // TODO check src/components/my/order/DeliveringItem.vue:60
      // const url = process.env.VUE_APP_ORDER_HISTORY_DETAIL_URL
      // window.location.href = `${url}${orderId}`

      this.$appManager.move(
        Location.ORDER_HISTORY_DETAIL,
        this.$store.getters.isAndroid,
        MoveType.PUSH,
        {
          orderHistoryDetail_shopType: 'market',
          orderHistoryDetail_orderNo: orderId
        }
      )
    },
    redirectDeliveryTracking(orderId) {
      // TODO check src/components/my/order/MoveDeliveryTracking.vue:15
      // const deliveryTrackingUrl = process.env.VUE_APP_ORDER_HISTORY_DELIVERY_TRACKING_URL
      // window.location.href = `${deliveryTrackingUrl}${orderId}`
      this.$appManager.move(
        Location.ORDER_HISTORY_DELIVERY_TRACKING_URL,
        this.$store.getters.isAndroid,
        MoveType.PUSH,
        {
          marketDeliveryTracking_orderNo: orderId
        }
      )
    },
    onChatbot(orderId) {
      if (this.chatbotStatus.isClosedCenter()) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: this.chatbotStatus.closedPopupMessage(),
          onOK: async () => {
            this.$store.dispatch('modal/close')
          },
          onCancel: async () => {}
        })
      } else {
        window.location.replace(`${process.env.VUE_APP_GO_TO_CHATBOT}${orderId}`)
      }

      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_HIST,
        type: LogType.CLICK,
        group: LogGroup.LIVE_CHAT,
        event: LogEvent.LIVE_CHAT_CENTER,
        params: {
          OrdNo: String(orderId)
        }
      })
    }
  }
}
</script>

<style scoped></style>
